module.exports = __webpack_public_path__ + "img/15.904b3779.png";